// 系统相关配置
let conf = {
	// 本地测试地址
	apiBaseUrl: '',
	// apiBaseImg:'https://mancenter.renhegroup.net/website-api',
	// apiBaseUrl: '',
	// 图片拼接地址
	apiBaseImg: '',
	// 上传图片接口
	uploadImg: 'https://mancenter.renhegroup.net/website-api/'

	// uploadImg: '192.168.0.28:8900'
	// apiUrl: 'http://hunshui.xxcf.net/public/html/phone/index.html#/',
	// apiUrl: 'http://hunshui.xxcf.net/public/html/index.html#/indexMain',

}

module.exports = conf



// WEBPACK FOOTER //
// ./src/assets/js/settings.js